import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NativeDesktopTooltip } from "./native-desktop-tooltip";
import { NativeDesktopDropdown } from "./native-desktop-dropdown";
import { NativeDesktopStyle } from "./native-desktop-style";
import { NativeDesktopClass } from "./native-desktop-class";
import { NativeDesktopCalendar } from "./native-desktop-calendar";
import { NativeDesktopMenu } from "./native-desktop-menu";
import { NativeDesktopTable } from "./native-desktop-table";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { NativeDesktopAppNotification } from "./native-desktop-app-notification";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { NativeDesktopPCalendar } from "./native-desktop-p-calendar";
import { OwnerDocumentPCalendar } from "./owner-document/owner-document-p-calendar";

@NgModule({
  imports: [CommonModule, BfxElementsLibraryModule, DataTableModule, DialogModule],
  declarations: [
    NativeDesktopTooltip,
    NativeDesktopDropdown,
    NativeDesktopStyle,
    NativeDesktopClass,
    NativeDesktopCalendar,
    NativeDesktopPCalendar,
    NativeDesktopTable,
    NativeDesktopMenu,
    NativeDesktopAppNotification,
    OwnerDocumentPCalendar,
  ],
  providers: [],
  exports: [
    NativeDesktopTooltip,
    NativeDesktopDropdown,
    NativeDesktopCalendar,
    NativeDesktopPCalendar,
    OwnerDocumentPCalendar,
    NativeDesktopStyle,
    NativeDesktopClass,
    NativeDesktopTable,
    NativeDesktopMenu,
    NativeDesktopAppNotification,
  ],
})
export class NativeDesktopModule {}
